import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavigatorComponent } from 'routes/layouts/navigator';
import { Breadcrumbs } from 'routes/layouts/breadcrumbs';

import s from './Layout.module.scss';
import { Box } from '@chakra-ui/react';

export const LayoutWithNavigation = (): JSX.Element => (
  <>
    <Box display={{ base: 'none', md: 'block' }}>
      <NavigatorComponent />
    </Box>
    <main className={s.layout__content}>
      <Breadcrumbs />
      <Outlet />
    </main>
  </>
);
